// Utility helpers for feature flag parsing
export const getFlagValue = (value) => {
  if (value === undefined || value === null) return false;
  try {
    return ['true', '1', 'yes', 'on'].includes(String(value).toLowerCase());
  } catch (e) {
    return false;
  }
};

export default getFlagValue;
